<a class="abook-skip-link" [href]="'#' + target" (click)="skip($event)">Gå til indhold</a>
